import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { initialize } from './actionCreators';
import { Props } from './UserAvatarPopover';
import { getIsInitialized, getTooltipState } from './selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { UserAvatarPopoverStoreState } from './types';

type StateProps = Pick<Props, 'isInitialized' | 'isOwner' | 'isLoading' | 'isError' | 'data'>;
type DispatchProps = Pick<Props, 'initialize'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, UserAvatarPopoverStoreState> = (
  state,
  ownProps
) => {
  const { username } = ownProps;
  const currentUser = getCurrentUser(state);

  return {
    isInitialized: getIsInitialized(state, username),
    isOwner: currentUser && currentUser.username === username,
    ...getTooltipState(state, username),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  initialize: (username: string) => dispatch(initialize(username)),
});

export default connect(mapStateToProps, mapDispatchToProps);
